<mat-progress-bar [mode]="loading() ? 'indeterminate' : 'determinate'" [value]="100" class="page-progress" aria-label="Loading"></mat-progress-bar>

<lib-page-header [title]="runner()?.name || runner()?.host || 'Runner'" screenName="Runner Detail" backTo="/administration/runners">
    <mat-icon icon>memory</mat-icon>
    <ng-container subtitle *ngIf="runner()">
        <span class="runner-status-pill" [class.online]="!isStale()" [class.stale]="isStale()">
            <mat-icon class="status-pill-icon">{{ isStale() ? 'cloud_off' : 'check_circle' }}</mat-icon>
            {{ isStale() ? 'Stale' : 'Online' }}
        </span>
        <span class="runner-id-mono">{{ runner()?.runnerId }}</span>
    </ng-container>
    <ng-container actions>
        <button mat-stroked-button (click)="onBack()"><mat-icon>arrow_back</mat-icon> Back</button>
    </ng-container>
</lib-page-header>

<div class="main-content runner-detail" *ngIf="runner() as r">

    <mat-card class="app-panel detail-panel">
        <mat-card-content>
            <div class="detail-grid">
                <div class="detail-field">
                    <label>Name</label>
                    <span><strong>{{ r.name || '—' }}</strong></span>
                </div>
                <div class="detail-field">
                    <label>Host</label>
                    <span>{{ r.host }}</span>
                </div>
                <div class="detail-field">
                    <label>Endpoint</label>
                    <span *ngIf="r.ip && r.port">{{ r.ip }}:{{ r.port }}</span>
                    <span *ngIf="r.ip && !r.port">{{ r.ip }}</span>
                    <span *ngIf="!r.ip">—</span>
                </div>
                <div class="detail-field">
                    <label>PID</label>
                    <span>{{ r.pid }}</span>
                </div>
                <div class="detail-field">
                    <label>Domain</label>
                    <span>{{ r.domain || '—' }}</span>
                </div>
                <div class="detail-field">
                    <label>Runner Version</label>
                    <span>{{ r.runnerVersion || '—' }}</span>
                </div>
                <div class="detail-field">
                    <label>Skeleton Version</label>
                    <span>{{ r.skeletonVersion || '—' }}</span>
                </div>
                <div class="detail-field">
                    <label>Max Concurrency</label>
                    <span>{{ r.maxConcurrency }} slot{{ r.maxConcurrency === 1 ? '' : 's' }}</span>
                </div>
                <div class="detail-field">
                    <label>Tenant ID</label>
                    <span>{{ r.tenantId || '—' }}</span>
                </div>
                <div class="detail-field">
                    <label>Capabilities</label>
                    <span>{{ formatList(r.tags) || '—' }}</span>
                </div>
                <div class="detail-field">
                    <label>Connectors</label>
                    <span>{{ formatList(r.connectors) || '—' }}</span>
                </div>
                <div class="detail-field">
                    <label>Tenants Allowed</label>
                    <span>{{ formatList(r.tenantsAllowed) || 'all (unrestricted)' }}</span>
                </div>
                <div class="detail-field">
                    <label>Registered At</label>
                    <span>{{ r.registeredAt | date: 'medium' }}</span>
                </div>
                <div class="detail-field">
                    <label>Last Seen</label>
                    <span>{{ r.lastSeen | date: 'medium' }}</span>
                </div>
                <div class="detail-field">
                    <label>Last Event ID</label>
                    <span class="runner-id-mono">{{ r.lastEventId || '—' }}</span>
                </div>
            </div>
        </mat-card-content>
    </mat-card>

    <mat-card class="app-panel detail-panel" *ngIf="r.containerized !== false">
        <mat-card-header><mat-card-title>Container</mat-card-title></mat-card-header>
        <mat-card-content>
            <div class="detail-grid">
                <div class="detail-field">
                    <label>Containerized</label>
                    <span *ngIf="r.containerized === true">
                        <mat-icon class="container-icon">check_circle</mat-icon> Yes
                    </span>
                    <span *ngIf="r.containerized == null">unknown</span>
                </div>
                <div class="detail-field" *ngIf="r.containerName">
                    <label>Container Name</label>
                    <span><strong>{{ r.containerName }}</strong></span>
                </div>
                <div class="detail-field" *ngIf="r.containerId">
                    <label>Container ID</label>
                    <span class="runner-id-mono">{{ r.containerId }}</span>
                </div>
                <div class="detail-field" *ngIf="r.containerImage">
                    <label>Image</label>
                    <span class="runner-id-mono">{{ r.containerImage }}</span>
                </div>
            </div>
        </mat-card-content>
    </mat-card>

    <mat-card class="app-panel detail-panel" *ngIf="tasksOffered().length > 0">
        <mat-card-header>
            <mat-card-title>Tasks Offered</mat-card-title>
            <mat-card-subtitle>
                What this runner can be asked to execute, and the input each task expects
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <div class="task-offered" *ngFor="let t of tasksOffered()">
                <div class="task-offered-header" (click)="toggleExpand(t)">
                    <mat-icon class="task-expand-caret">
                        {{ isExpanded(t) ? 'expand_more' : 'chevron_right' }}
                    </mat-icon>
                    <div class="task-offered-name">
                        <strong>{{ t.name || t.taskType }}</strong>
                        <span class="task-offered-meta">
                            <span class="task-offered-type">{{ t.taskType }}</span>
                            <span class="task-offered-version">v{{ t.definitionVersion }}</span>
                        </span>
                        <div class="task-offered-description" *ngIf="t.description">{{ t.description }}</div>
                    </div>
                    <div class="task-offered-hint">{{ requiredFieldHint(t.inputSchema) }}</div>
                </div>

                <div class="task-offered-body" *ngIf="isExpanded(t)">
                    <div class="task-offered-row" *ngIf="t.tags?.length">
                        <label>Capabilities</label>
                        <span>{{ formatList(t.tags) }}</span>
                    </div>
                    <div class="task-offered-row">
                        <label>Lifecycle</label>
                        <div class="lifecycle-pills">
                            <span class="lifecycle-pill"
                                  [class.on]="t.executionPolicy?.cancellable === true"
                                  [class.off]="t.executionPolicy?.cancellable === false">
                                <mat-icon>{{ t.executionPolicy?.cancellable ? 'check_circle' : 'do_not_disturb_on' }}</mat-icon>
                                Cancellable
                            </span>
                            <span class="lifecycle-pill"
                                  [class.on]="t.executionPolicy?.suspendable === true"
                                  [class.off]="t.executionPolicy?.suspendable === false">
                                <mat-icon>{{ t.executionPolicy?.suspendable ? 'check_circle' : 'do_not_disturb_on' }}</mat-icon>
                                Suspendable
                            </span>
                            <span class="lifecycle-pill"
                                  [class.on]="t.executionPolicy?.resumable === true"
                                  [class.off]="t.executionPolicy?.resumable === false">
                                <mat-icon>{{ t.executionPolicy?.resumable ? 'check_circle' : 'do_not_disturb_on' }}</mat-icon>
                                Resumable
                            </span>
                            <span class="lifecycle-pill timeout"
                                  *ngIf="t.executionPolicy?.timeoutSeconds">
                                <mat-icon>timer</mat-icon>
                                {{ t.executionPolicy?.timeoutSeconds }}s timeout
                            </span>
                        </div>
                    </div>
                    <div class="task-offered-row">
                        <label>Input Schema</label>
                        <pre class="task-input-schema" *ngIf="t.inputSchema">{{ formatJson(t.inputSchema) }}</pre>
                        <span class="task-input-schema-empty" *ngIf="!t.inputSchema">
                            This task accepts no input parameters.
                        </span>
                    </div>
                </div>
            </div>
        </mat-card-content>
    </mat-card>

    <mat-card class="app-panel detail-panel" *ngIf="r.tags?.length || r.connectors?.length">
        <mat-card-header><mat-card-title>Raw Registration Payload</mat-card-title></mat-card-header>
        <mat-card-content>
            <div class="raw-block" *ngIf="r.tags?.length">
                <h4>capabilities</h4>
                <pre>{{ formatJson(r.tags) }}</pre>
            </div>
            <div class="raw-block" *ngIf="r.connectors?.length">
                <h4>connectors</h4>
                <pre>{{ formatJson(r.connectors) }}</pre>
            </div>
            <div class="raw-block" *ngIf="r.tenantsAllowed?.length">
                <h4>tenants_allowed</h4>
                <pre>{{ formatJson(r.tenantsAllowed) }}</pre>
            </div>
        </mat-card-content>
    </mat-card>
</div>
